import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { ClientCustomService } from "../service";
import { ErrorToast, SuccessToast } from "../../../shared/toasters/toasters";
import { Button, Table } from "react-bootstrap";
import { t } from "i18next";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";
export const ClientCustomById = () => {
  const { id, variationId } = useParams();
  const navigate = useNavigate();
  const booleanOptions = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];
  const [product, setProduct] = useState<any>({});
  const [formData, setFormData] = useState<any>({
    name: {},
    description: {},
    slug: {},
  });
  const [search, setSearch] = useState<string>("");
  const [originalFormData, setOriginalFormData] = useState<any>({
    name: {},
    description: {},
    slug: {},
  });

  const [fieldLangs, setFieldLangs] = useState<{
    name: string[];
    description: string[];
    slug: string[];
  }>({
    name: [],
    description: [],
    slug: [],
  });

  const [attributes, setAttributes] = useState<any[]>([]);
  const [attributesChanged, setAttributesChanged] = useState<
    Record<string, boolean>
  >({});

  const changeHandler = (event: any) => {
    const { value } = event.target;
    setSearch(value);
  };
  useEffect(() => {
    ClientCustomService.getSemgProduct(id as any, variationId)
      .then((response: any) => {
        setProduct(response);

        const nameLangs = Object.keys(
          response?.masterData?.current?.name || {}
        );
        const descriptionLangs = Object.keys(
          response?.masterData?.current?.description || {}
        );
        const slugLangs = Object.keys(
          response?.masterData?.current?.slug || {}
        );

        setFieldLangs({
          name: nameLangs,
          description: descriptionLangs,
          slug: slugLangs,
        });

        const initialFormData = {
          name: { ...response?.masterData?.current?.name },
          description: { ...response?.masterData?.current?.description },
          slug: { ...response?.masterData?.current?.slug },
        };

        setFormData(initialFormData);
        setOriginalFormData(initialFormData);

        setAttributes(response?.variant?.attributes || []);
        setAttributesChanged(
          (response?.variant?.attributes || []).map(() => false)
        );
      })
      .catch((error: any) => ErrorToast(error));
  }, [id, variationId]);

  const isFieldChanged = (field: "name" | "description" | "slug") => {
    const current = formData[field] || {};
    const original = originalFormData[field] || {};

    const allKeys = new Set([
      ...Object.keys(current),
      ...Object.keys(original),
    ]) as any;
    for (const key of allKeys) {
      if ((current[key] || "") !== (original[key] || "")) {
        return true;
      }
    }
    return false;
  };

  const handleInputChange = (
    field: "name" | "description" | "slug",
    lang: string,
    value: string
  ) => {
    setFormData((prev: any) => ({
      ...prev,
      [field]: {
        ...prev[field],
        [lang]: value,
      },
    }));
  };

  const submitHandler = (
    event: React.FormEvent,
    field: "name" | "description" | "slug"
  ) => {
    event.preventDefault();

    if (product?.id) {
      ClientCustomService.updateProductById(product?.id, {
        field: field,
        value: formData?.[field],
        variantId: product?.variant?.id,
      } as any)
        .then(() => {
          SuccessToast(`${t("toasts.successfully_updated")}`);
          setOriginalFormData((prev: any) => ({
            ...prev,
            [field]: { ...formData[field] },
          }));
        })
        .catch((error) => ErrorToast(error));
    }
  };

  const handleAttributeChange = (attrName: string, newValue: any) => {
    setAttributes((prev) =>
      prev.map((attr) =>
        attr.name === attrName ? { ...attr, value: newValue } : attr
      )
    );

    setAttributesChanged((prev) => ({
      ...prev,
      [attrName]: true,
    }));
  };
  const handleLanguageObjectAttributeChange = (
    attrName: string,
    lang: string,
    newValue: string
  ) => {
    setAttributes((prev) =>
      prev.map((attr) => {
        if (
          attr.name === attrName &&
          attr.value &&
          typeof attr.value === "object"
        ) {
          return {
            ...attr,
            value: {
              ...attr.value,
              [lang]: newValue,
            },
          };
        }
        return attr;
      })
    );

    setAttributesChanged((prev) => ({
      ...prev,
      [attrName]: true,
    }));
  };

  const submitAttributes = (attrName: string) => {
    if (!product?.id) return;

    const attr = attributes.find((a) => a.name === attrName);
    if (!attr) return;

    ClientCustomService.updateProductAttributeById(product.id, {
      field: attr.name,
      value: attr.value,
      type: attr.type,
      variantId: product?.variant?.id,
    } as any)
      .then(() => {
        SuccessToast(`${t("toasts.successfully_updated")}`);
        setAttributesChanged((prev) => ({
          ...prev,
          [attrName]: false,
        }));
      })
      .catch((error) => ErrorToast(error));
  };
  const renderValue = (value: any): React.ReactNode => {
    if (value === undefined || value === null) {
      return "-";
    }
    if (typeof value === "object") {
      if (Array.isArray(value)) {
        return value.join(", ");
      }
      return (
        <ul
          className="mb-0 ps-3"
          style={{ listStyle: "none", textAlign: "start" }}
        >
          {Object.entries(value).map(([key, val]) => (
            <li key={key}>
              <strong>{key}</strong>:{" "}
              {typeof val === "object" && val !== null
                ? renderValue(val)
                : String(val)}
            </li>
          ))}
        </ul>
      );
    }
    return String(value);
  };
  const renderAttributes = (attributesToRender: any[]) => {
    if (!attributesToRender || attributesToRender.length === 0)
      return <p>{t("custom_client.no_attributes_available")}</p>;

    return (
      <div className="table-responsive mt-4">
        <Table bordered striped size="sm">
          <thead>
            <tr>
              <th>{t("custom_client.attribute_name")}</th>
              <th>{t("global.value")}</th>
            </tr>
          </thead>
          <tbody>
            {attributesToRender.map((attr) => {
              const { name, value, type, values, color } = attr;
              if (type === "text") {
                return (
                  <tr key={name}>
                    <td className="align-middle">
                      <span
                        style={{
                          color:
                            color === "green" ? "#06aed4" : color || undefined,
                        }}
                      >
                        {name}
                      </span>
                    </td>
                    <td className="text-start">
                      <input
                        type="text"
                        className="form-control"
                        value={value || ""}
                        onChange={(e) =>
                          handleAttributeChange(name, e.target.value)
                        }
                      />
                      <div className="d-flex justify-content-end">
                        <Button
                          variant="info"
                          size="sm"
                          className="mt-1"
                          onClick={() => submitAttributes(name)}
                          disabled={!attributesChanged[name]}
                        >
                          {t("global.save")}
                        </Button>
                      </div>
                    </td>
                  </tr>
                );
              }

              if (type === "number") {
                return (
                  <tr key={name}>
                    <td className="align-middle">
                      {" "}
                      <span
                        style={{
                          color:
                            color == "green"
                              ? "#06aed4"
                              : color
                              ? color
                              : undefined,
                        }}
                      >
                        {name}
                      </span>
                    </td>
                    <td className="text-start">
                      <input
                        type="number"
                        className="form-control"
                        value={value || ""}
                        onChange={(e) =>
                          handleAttributeChange(
                            name,
                            e.target.value === ""
                              ? null
                              : Number(e.target.value)
                          )
                        }
                      />
                      <div className="d-flex justify-content-end">
                        <Button
                          variant="info"
                          size="sm"
                          className="mt-1"
                          onClick={() => submitAttributes(name)}
                          disabled={!attributesChanged[name]}
                        >
                          {t("global.save")}
                        </Button>
                      </div>
                    </td>
                  </tr>
                );
              }
              if (type === "boolean") {
                return (
                  <tr key={name}>
                    <td className="align-middle">
                      {" "}
                      <span
                        style={{
                          color:
                            color == "green"
                              ? "#06aed4"
                              : color
                              ? color
                              : undefined,
                        }}
                      >
                        {name}
                      </span>
                    </td>
                    <td className="text-start d-flex justify-content-center align-items-center">
                      <Select
                        styles={{
                          control: (base: any) => ({
                            ...base,
                            minWidth: 200,
                            marginRight: "8px",
                          }),
                        }}
                        isClearable
                        options={booleanOptions}
                        value={
                          value === true
                            ? booleanOptions[0]
                            : value === false
                            ? booleanOptions[1]
                            : null
                        }
                        onChange={(selected) => {
                          handleAttributeChange(
                            name,
                            selected ? selected.value : null
                          );
                        }}
                      />
                      <div className="d-flex justify-content-end">
                        <Button
                          variant="info"
                          size="sm"
                          className="mt-1"
                          onClick={() => submitAttributes(name)}
                          disabled={!attributesChanged[name]}
                        >
                          {t("global.save")}
                        </Button>
                      </div>
                    </td>
                  </tr>
                );
              }
              if (type === "date") {
                return (
                  <tr key={name}>
                    <td className="align-middle">
                      {" "}
                      <span
                        style={{
                          color:
                            color == "green"
                              ? "#06aed4"
                              : color
                              ? color
                              : undefined,
                        }}
                      >
                        {name}
                      </span>
                    </td>
                    <td className="text-start">
                      <DatePicker
                        selected={value ? new Date(value) : null}
                        dateFormat="dd.MM.yyyy"
                        onChange={(date) => {
                          if (date) {
                            const d = new Date(date);
                            const year = d.getFullYear();
                            const month = (d.getMonth() + 1)
                              .toString()
                              .padStart(2, "0");
                            const day = d.getDate().toString().padStart(2, "0");
                            const formatted = `${year}-${month}-${day}`;
                            handleAttributeChange(name, formatted);
                          } else {
                            handleAttributeChange(name, null);
                          }
                        }}
                        className="form-control"
                        isClearable
                      />
                      <div className="d-flex justify-content-end">
                        <Button
                          variant="info"
                          size="sm"
                          className="mt-1"
                          onClick={() => submitAttributes(name)}
                          disabled={!attributesChanged[name]}
                        >
                          {t("global.save")}
                        </Button>
                      </div>
                    </td>
                  </tr>
                );
              }
              if (type === "string-array" && Array.isArray(value)) {
                return (
                  <tr key={name}>
                    <td className="align-middle">
                      {" "}
                      <span
                        style={{
                          color:
                            color == "green"
                              ? "#06aed4"
                              : color
                              ? color
                              : undefined,
                        }}
                      >
                        {name}
                      </span>
                    </td>
                    <td className="text-start">
                      {value.map((item: string, arrIndex: number) => (
                        <div
                          key={arrIndex}
                          className="d-flex align-items-center mb-2"
                        >
                          <input
                            type="text"
                            className="form-control me-2"
                            value={item || ""}
                            onChange={(e) => {
                              const updatedArray = [...value];
                              updatedArray[arrIndex] = e.target.value;
                              handleAttributeChange(name, updatedArray);
                            }}
                          />
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => {
                              const updatedArray = value.filter(
                                (_, i) => i !== arrIndex
                              );
                              handleAttributeChange(name, updatedArray);
                            }}
                          >
                            <i className="ri-delete-bin-line"></i>
                          </button>
                        </div>
                      ))}

                      <div className="d-flex justify-content-end mt-2">
                        <button
                          type="button"
                          className="btn btn-outline-success btn-sm me-2"
                          onClick={() => {
                            handleAttributeChange(name, [...value, ""]);
                          }}
                        >
                          <i className="ri-add-line"></i> Add
                        </button>
                        <button
                          type="button"
                          className="btn btn-info btn-sm"
                          onClick={() => submitAttributes(name)}
                          disabled={!attributesChanged[name]}
                        >
                          {t("global.save")}
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              }
              if (type === "lenum" && Array.isArray(values)) {
                const options = values.map((item) => {
                  const [langKey, langValue] = Object.entries(item.label)[0];
                  return {
                    value: item.key,
                    label: `${langKey}: ${langValue}`,
                  };
                });

                return (
                  <tr key={name}>
                    <td className="align-middle">
                      {" "}
                      <span
                        style={{
                          color:
                            color == "green"
                              ? "#06aed4"
                              : color
                              ? color
                              : undefined,
                        }}
                      >
                        {name}
                      </span>
                    </td>
                    <td className="text-start">
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        options={options}
                        value={
                          value
                            ? options.find((opt) => opt.value === value)
                            : null
                        }
                        onChange={(selectedOption) => {
                          handleAttributeChange(
                            name,
                            selectedOption?.value || null
                          );
                        }}
                        isClearable
                      />

                      <div className="d-flex justify-content-end mt-2">
                        <button
                          type="button"
                          className="btn btn-info btn-sm"
                          onClick={() => submitAttributes(name)}
                          disabled={!attributesChanged[name]}
                        >
                          {t("global.save")}
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              }
              if (
                type === "language-object" &&
                typeof value === "object" &&
                value !== null
              ) {
                const isDescriptionField = /description/i.test(name);
                return (
                  <tr key={name}>
                    <td className="align-middle">
                      {" "}
                      <span
                        style={{
                          color:
                            color == "green"
                              ? "#06aed4"
                              : color
                              ? color
                              : undefined,
                        }}
                      >
                        {name}
                      </span>
                    </td>
                    <td className="text-start">
                      {Object.entries(value).map(([lang, langValue]: any) => (
                        <div
                          key={lang}
                          className="mb-2 d-flex align-items-center"
                        >
                          <label
                            className="form-label me-2 mb-0"
                            style={{ fontWeight: "bold", minWidth: "60px" }}
                          >
                            {lang.toUpperCase()}:
                          </label>
                          {isDescriptionField ? (
                            <textarea
                              className="form-control"
                              rows={3}
                              value={langValue || ""}
                              onChange={(e) =>
                                handleLanguageObjectAttributeChange(
                                  name,
                                  lang,
                                  e.target.value
                                )
                              }
                            />
                          ) : (
                            <input
                              type="text"
                              className="form-control"
                              value={langValue || ""}
                              onChange={(e) =>
                                handleLanguageObjectAttributeChange(
                                  name,
                                  lang,
                                  e.target.value
                                )
                              }
                            />
                          )}
                        </div>
                      ))}
                      <div className="d-flex justify-content-end">
                        <Button
                          variant="info"
                          size="sm"
                          onClick={() => submitAttributes(name)}
                          disabled={!attributesChanged[name]}
                        >
                          {t("global.save")}
                        </Button>
                      </div>
                    </td>
                  </tr>
                );
              }

              return (
                <tr key={name}>
                  <td className="align-middle">
                    {" "}
                    <span
                      style={{
                        color:
                          color == "green"
                            ? "#06aed4"
                            : color
                            ? color
                            : undefined,
                      }}
                    >
                      {name}
                    </span>
                  </td>
                  <td className="text-start">{renderValue(value)}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  };

  const filteredAttributes = React.useMemo(() => {
    if (!search) return attributes;
    const searchTerms = search
      .split(" ")
      .map((s) => s.trim().toLowerCase())
      .filter((s) => s.length > 0);

    return attributes.filter((attr: any) =>
      searchTerms.some((term) => attr.name?.toLowerCase() === term)
    );
  }, [search, attributes]);
  useEffect(() => {
    const div = document.querySelector("div.row.mx-0.w-100");
    if (div) {
      div.classList.remove("row", "mx-0", "w-100");
    }

    const pageContent = document.querySelector(".page-content") as HTMLElement;
    const originalPaddingLeft = pageContent?.style.paddingLeft;
    const originalPaddingRight = pageContent?.style.paddingRight;

    if (pageContent) {
      pageContent.style.setProperty("padding-left", "0", "important");
      pageContent.style.setProperty("padding-right", "0", "important");
    }

    return () => {
      if (div) {
        div.classList.add("row", "mx-0", "w-100");
      }
      if (pageContent) {
        if (originalPaddingLeft) {
          pageContent.style.setProperty(
            "padding-left",
            originalPaddingLeft,
            "important"
          );
        } else {
          pageContent.style.removeProperty("padding-left");
        }

        if (originalPaddingRight) {
          pageContent.style.setProperty(
            "padding-right",
            originalPaddingRight,
            "important"
          );
        } else {
          pageContent.style.removeProperty("padding-right");
        }
      }
    };
  }, []);
  return (
    <div className="product-details">
      <div
        className="mb-4 sticky-top bg-white p-3"
        style={{ top: "70px", zIndex: 1020, paddingTop: "8px" }}
      >
        <ul
          className="nav nav-tabs-custom rounded card-header-tabs border-bottom-0 pb-5"
          role="tablist"
        >
          <li className="nav-item">
            <a
              href="/"
              role="tab"
              data-bs-toggle="tab"
              className="nav-link active"
              aria-selected="true"
            >
              {t("manage.BASE_DATA")}
            </a>
          </li>
          <li className="nav-item">
            <Link
              to={`/app/clients/semg/media/${id}/${variationId}`}
              role="tab"
              className="nav-link"
              aria-selected="true"
            >
              {t("manage.MEDIA")}
            </Link>
          </li>
        </ul>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h3 className="mb-0">{t("custom_client.product_info")}</h3>
          <Button
            variant="primary"
            onClick={() => navigate("/app/clients/semg")}
            className="btn btn-primary d-flex align-items-center"
          >
            <i className="ri-arrow-left-line me-1" />
            {t("block.back")}
          </Button>
        </div>
        <input
          type="text"
          name="name"
          placeholder={`${t("mapping.type_attribute_names")}...`}
          className="form-control"
          value={search ?? ""}
          onChange={changeHandler}
        />
      </div>
      {/* NAME */}
      <div className="px-3">
        <div className="mt-3">
          <h4>{t("global.name")}</h4>
          {fieldLangs.name.map((lang) => (
            <div key={lang} className="mb-2">
              <label className="form-label">{lang.toUpperCase()}</label>
              <input
                type="text"
                className="form-control"
                value={formData.name[lang] || ""}
                onChange={(e) =>
                  handleInputChange("name", lang, e.target.value)
                }
              />
            </div>
          ))}
          <div className="d-flex justify-content-end align-items-center">
            <button
              className="btn btn-info"
              onClick={(e) => submitHandler(e, "name")}
              disabled={!isFieldChanged("name")}
            >
              {t("global.save")}
            </button>
          </div>
        </div>

        {/* DESCRIPTION */}
        <div className="">
          <h4> {t("mapping.description")}</h4>
          {fieldLangs.description.map((lang) => (
            <div key={lang} className="mb-2">
              <label className="form-label">{lang.toUpperCase()}</label>
              <textarea
                className="form-control"
                rows={3}
                value={formData.description[lang] || ""}
                onChange={(e) =>
                  handleInputChange("description", lang, e.target.value)
                }
              />
            </div>
          ))}
          <div className="d-flex justify-content-end align-items-center">
            <button
              className="btn btn-info"
              onClick={(e) => submitHandler(e, "description")}
              disabled={!isFieldChanged("description")}
            >
              {t("global.save")}
            </button>
          </div>
        </div>

        {/* SLUG */}
        <div className="">
          <h4>{t("custom_client.slug")}</h4>
          {fieldLangs.slug.map((lang) => (
            <div key={lang} className="mb-2">
              <label className="form-label">{lang.toUpperCase()}</label>
              <input
                type="text"
                className="form-control"
                value={formData.slug[lang] || ""}
                onChange={(e) =>
                  handleInputChange("slug", lang, e.target.value)
                }
              />
            </div>
          ))}
          <div className="d-flex justify-content-end align-items-center">
            <button
              className="btn btn-info"
              onClick={(e) => submitHandler(e, "slug")}
              disabled={!isFieldChanged("slug")}
            >
              {t("global.save")}
            </button>
          </div>
        </div>

        {/* ATTRIBUTES */}
        <div className="mb-4">
          <h4> {t("side_bar.attributes")}</h4>

          {renderAttributes(filteredAttributes)}
        </div>
      </div>
    </div>
  );
};
